(function(ns) {
	"use strict";

	var util = ns.util;

	var defaultPosition = {lat: 0, lng: 180}; // 太平洋のど真ん中
	// var defaultPosition = {lat: 36.594600, lng: 136.625747}; // 石川県庁
	var defaultZoom = 16;

	util.component("map-editor", {
		props: {
			googlemaps: Object,
			lat: Number,
			lng: Number,
			address: String,
		},
		data: function() {
			return {
				map: null,
				marker: null,
			};
		},
		mounted: function() {
			if (this.googlemaps && !this.map) {
				this.initMap();
			}
		},
		watch: {
			googlemaps: function() {
				if (this.googlemaps && !this.map) {
					this.initMap();
				}
			},
		},
		methods: {
			initMap: function() {
				var me = this;
				var GM = me.googlemaps;
				var position = (me.lat != null && me.lng != null) ? {lat: me.lat, lng: me.lng} : defaultPosition;
				var mapE = me.$el.querySelector(".map-editor-map");
				mapE.style.height = "320px";

				me.map = new GM.Map(mapE, {
					mapTypeId: GM.MapTypeId.ROADMAP,
					center: position,
					zoom: defaultZoom,
					mapTypeControl: false,
					streetViewControl: false,
					fullscreenControl: false,
					clickableIcons: false,
				});

				me.marker = new GM.Marker({
					map: me.map,
					position: position,
					title: "ドラッグして移動することができます",
					draggable: true,
					bouncy: false,
				});

				GM.event.addListener(me.marker, "position_changed", function() {
					var pos = me.marker.getPosition();
					me.$emit("positionupdate", {lat: pos.lat(), lng: pos.lng()});
				});
			},
			geocode: function() {
				var me = this;
				if (!me.googlemaps) return;

				var GM = me.googlemaps;
				var geocoder = new GM.Geocoder;
				geocoder.geocode({ address: me.address }, function(results, status) {
					if (status !== GM.GeocoderStatus.OK) {
						alert("お探しの住所は見つかりませんでした");
						console.warn("お探しの住所は見つかりませんでした: " + status);
						return;
					}
					var location = results[0].geometry.location;
					var latlng = {lat: location.lat(), lng: location.lng()};
					me.marker.setPosition(latlng);
					me.map.setCenter(latlng);
					me.map.setZoom(defaultZoom);
					me.$emit("positionupdate", latlng);
				});
			},
		},
	});

})(CE);
